import React from 'react';
import { Button, Tooltip } from 'antd';
import { SunOutlined, MoonOutlined } from '@ant-design/icons';
import { useTheme } from '../context/ThemeContext';

/**
 * Accessible theme switch: sun/light vs moon/dark affordance (Ant icons).
 */
export default function ThemeToggle({ size = 'middle', type = 'text', ...buttonProps }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <Tooltip title={isDark ? 'Switch to light theme' : 'Switch to dark theme'}>
      <Button
        type={type}
        size={size}
        aria-label={isDark ? 'Activate light theme' : 'Activate dark theme'}
        icon={isDark ? <SunOutlined /> : <MoonOutlined />}
        onClick={toggleTheme}
        {...buttonProps}
      />
    </Tooltip>
  );
}
